import { useMutation, useQuery } from "react-query";
import { RequestService } from "../services/requests-service";
import { cacheKey } from "./cacheStateKey";

export const useGetAccessRequests = (
	page = 0,
	pageSize = 50,
  serch?: string
) => {
	const result = useQuery({
		queryKey: [cacheKey.accessRequests, page, serch],
		queryFn: () =>
			RequestService.getAccessRequests(page, pageSize, serch),
		keepPreviousData: true,
	});
	return result;
};

export const useGetAccessRequestStats = () => {
	const result = useQuery({
		queryKey: [cacheKey.accessRequestStats],
		queryFn: () => RequestService.getRequestStats(),
	});
	return result;
};

export const useApproveRequest = () => {
	const result = useMutation(RequestService.approveRequest);
	return result;
};

export const useEnableRequest = () => {
	const result = useMutation(RequestService.enableRequest);
	return result;
};
